module.exports = __webpack_public_path__ + "img/nav_(3).7c6df8b5.png";